import { BarChartIcon, Cross2Icon } from '@radix-ui/react-icons';
import { Button, Badge, Dialog } from '@radix-ui/themes';
import type { PlainRank } from 'api/generated';
import HarmonizedRankExplanation from './HarmonizedRankExplanation';

export const HarmonizedRankBox: React.FC<{ currentRank?: PlainRank; playerId?: number }> = ({
  playerId,
  currentRank,
}) => (
  <div id='container' className='bg-accent-accent-6 flex flex-col items-start gap-4 self-stretch rounded-xl p-3'>
    <div id='topbar' className='flex flex-col items-start gap-2 self-stretch'>
      <div className='flex w-full flex-col items-start justify-between gap-2'>
        <div id='topbarsx' className='flex items-center gap-2'>
          <BarChartIcon width='16' height='16' />
          <div className='text-accent-accent-12 text-base leading-6 font-bold tracking-normal not-italic'>
            Classifica Armonizzata
          </div>
        </div>
        <div className='flex w-full flex-row gap-3'>
          <Badge className='bg-iris-9 flex w-auto items-center justify-start gap-1.5 rounded-md p-1 text-xs leading-4 font-medium tracking-wide text-white not-italic'>
            Esclusiva TennisTalker&#8482;&#xFE0E;
          </Badge>
        </div>
      </div>
    </div>
    <div
      id='copy'
      className='text-neutral-neutral-12 flex-1 items-center justify-between self-stretch text-sm font-normal'
    >
      La funzionalità 'Classifica Armonizzata' di TennisTalker permette di vedere la posizione di un giocatore nel
      ranking LIVE simulato che sarà quello utilizzato per determinare le classifiche FITP di fine anno.
    </div>

    <Dialog.Root>
      <Dialog.Trigger>
        <Button
          size={'3'}
          variant='outline'
          className='text-neutral-neutral-11 flex items-center self-stretch hover:cursor-pointer'
        >
          Classifica Armonizzata
        </Button>
      </Dialog.Trigger>
      <Dialog.Content maxWidth='450px'>
        <div className='flex w-full justify-between align-middle'>
          <Dialog.Title>Scopri la classifica armonizzata</Dialog.Title>
          <Dialog.Close className='mb-4 cursor-pointer'>
            <Cross2Icon height={'24'} width={'24'} />
          </Dialog.Close>
        </div>
        <Dialog.Description className='hidden'>Scopri la classifica armonizzata del giocatore</Dialog.Description>

        <div className='flex flex-1 flex-row flex-wrap items-center justify-center gap-4'>
          <HarmonizedRankExplanation currentRank={currentRank} playerId={playerId} />
        </div>
      </Dialog.Content>
    </Dialog.Root>
  </div>
);

export default HarmonizedRankBox;
